/**
 * Safe heading-text -> icon lookup for release-note `##` sections.
 *
 * Keyed on the normalised heading text (lowercased, whitespace collapsed) so
 * authors get a matching icon without hardcoding anything per release. Unknown
 * headings fall back to a neutral sparkle, so a new section name never breaks
 * rendering - it just gets the default icon until added here.
 */
import type { SvgIconComponent } from '@mui/icons-material'
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined'
import NewReleasesOutlinedIcon from '@mui/icons-material/NewReleasesOutlined'
import BuildOutlinedIcon from '@mui/icons-material/BuildOutlined'
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined'
import SupportOutlinedIcon from '@mui/icons-material/SupportOutlined'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'

const HEADING_ICONS: Record<string, SvgIconComponent> = {
  'main changes': NewReleasesOutlinedIcon,
  'fixes and polish': BuildOutlinedIcon,
  'fixes and cleanup': BuildOutlinedIcon,
  'tell us what you think': ForumOutlinedIcon,
  'support highlights': SupportOutlinedIcon,
  'things to know': InfoOutlinedIcon,
}

export function headingIconFor(heading: string): SvgIconComponent {
  const key = heading.toLowerCase().replace(/\s+/g, ' ').trim()
  return HEADING_ICONS[key] ?? AutoAwesomeOutlinedIcon
}
